import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

const routes: Routes = [
  {
    path: 'privacy-policy',
    loadComponent: async () => import('./privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent),
    data: {
        title: 'Privacy Policy'
    }
  },
  {
    path: 'refund-policy',
    loadComponent: async () => import('./refund-policy/refund-policy.component').then(m => m.RefundPolicyComponent),
    data: {
        title: 'Refund Policy'
    }
  },
  {
    path: 'shipping-policy',
    loadComponent: async () => import('./shipping-policy/shipping-policy.component').then(m => m.ShippingPolicyComponent),
    data: {
        title: 'Shipping Policy'
    }
  },
  {
    path: 'terms-of-service',
    loadComponent: async () => import('./terms-of-service/terms-of-service.component').then(m => m.TermsOfServiceComponent),
    data: {
        title: 'Terms of Service'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PoliciesRoutingModule { }
